module.exports = __webpack_public_path__ + "images/emoji/school_satchel.4d4e14daaa9ab3032b6a.png";